import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MENU_BUILDER_SERVICE } from '../../main-header-domain.module';
import { MainHeaderMenu, MenuStates, RouteData } from '../../models';

export interface MenuBuilderService {
    get menuState(): MenuStates;
    build$(routeData?: RouteData): Observable<MainHeaderMenu | null>;
}

@Injectable()
export class MenuBuilderCollectionService {
    constructor(
        @Inject(MENU_BUILDER_SERVICE)
        private readonly builders: MenuBuilderService[]
    ) {}

    get(menuState: MenuStates): MenuBuilderService {
        const builder = this.builders.find((x) => x.menuState === menuState);
        if (!builder) {
            throw new Error(`Menu builder does not exist for menu state '${MenuStates[menuState]}'`);
        }

        return builder;
    }
}
